module.exports = __webpack_public_path__ + "img/icon-checked.9ba9f388.svg";